import { createFileRoute } from '@tanstack/react-router'
import { AppShell } from '../../components/AppShell'
import { PlatformActivityLog } from '../../components/PlatformActivityLog'
import { useLogout, useSession } from '../../hooks/useApi'

export const Route = createFileRoute('/platform/log-aktivitas')({
  component: LogAktivitasPage,
})

function LogAktivitasPage() {
  const session = useSession()
  const logout = useLogout()
  const user = session.data?.user

  return (
    <AppShell
      mode="global"
      userName={user?.name ?? ''}
      userEmail={user?.email ?? ''}
      onLogout={() => logout.mutate()}
      userRole={user?.role}
      userIsQc={(user as any)?.is_qc}
    >
      <PlatformActivityLog />
    </AppShell>
  )
}
